import moment from 'moment';

/**
 * Checks if date passed is yesterday.
 * @param {string} dateIn - date.
 * @returns {boolean}
 */
export const isYesterday = dateIn => {
  if (dateIn) {
    const YESTERDAY = moment().clone().subtract(1, 'days').startOf('day');
    return moment(dateIn).isSame(YESTERDAY, 'd');
  }

  return false;
};
